import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

export async function createCrowd(scene, boundsSource, {
  glbUrl,           // 模型路径（.glb）
  count = 60,
  speed = { min: 0.4, max: 0.9 },
  y = 0.02,
} = {}) {
  // 1. 行走边界
  const box = new THREE.Box3().setFromObject(boundsSource)
  const pad = 4
  const min = new THREE.Vector3(box.min.x - pad, y, box.min.z - pad)
  const max = new THREE.Vector3(box.max.x + pad, y, box.max.z + pad)

  // 2. 加载模型
  const gltf = await new GLTFLoader().loadAsync(glbUrl)
  const baseModel = gltf.scene
  baseModel.traverse(obj => { if (obj.isMesh) obj.castShadow = obj.receiveShadow = true })

  // 3. 初始化状态
  const pos = [], dir = [], spd = [], clones = []
  const randPos = () => new THREE.Vector3(
    THREE.MathUtils.lerp(min.x, max.x, Math.random()), y,
    THREE.MathUtils.lerp(min.z, max.z, Math.random())
  )
  const randDir = () => new THREE.Vector3((Math.random() - 0.5), 0, (Math.random() - 0.5)).normalize()
  const randSpd = () => THREE.MathUtils.lerp(speed.min, speed.max, Math.random())

  for (let i = 0; i < count; i++) {
    const model = baseModel.clone(true)
    pos[i] = randPos()
    dir[i] = randDir()
    spd[i] = randSpd()
    model.position.copy(pos[i])
    model.scale.setScalar(0.3 + Math.random() * 0.2)
    scene.add(model)
    clones.push(model)
  }

  // 4. 更新函数
  function update(delta) {
    for (let i = 0; i < count; i++) {
      // 方向微调
      if (Math.random() < 0.01) dir[i].add(randDir().multiplyScalar(0.5)).normalize()
      pos[i].addScaledVector(dir[i], spd[i] * delta)

      // 边界反弹
      if (pos[i].x < min.x || pos[i].x > max.x) { dir[i].x *= -1; pos[i].x = THREE.MathUtils.clamp(pos[i].x, min.x, max.x) }
      if (pos[i].z < min.z || pos[i].z > max.z) { dir[i].z *= -1; pos[i].z = THREE.MathUtils.clamp(pos[i].z, min.z, max.z) }

      // 面向方向
      clones[i].position.copy(pos[i])
      const lookAt = pos[i].clone().add(dir[i])
      clones[i].lookAt(lookAt.x, y, lookAt.z)
    }
    return true
  }

  function dispose() {
    clones.forEach(obj => {
      scene.remove(obj)
      obj.traverse(n => {
        if (n.isMesh) {
          n.geometry?.dispose?.()
          if (Array.isArray(n.material)) n.material.forEach(m => m.dispose?.())
          else n.material?.dispose?.()
        }
      })
    })
    clones.length = 0
    if (baseModel) {
      baseModel.traverse(n => {
        if (n.isMesh) {
          n.geometry?.dispose?.()
          if (Array.isArray(n.material)) n.material.forEach(m => m.dispose?.())
          else n.material?.dispose?.()
        }
      })
    }
  }

  return { update, dispose }
}
